import { CheckCircleFilled } from "@ant-design/icons";
import to from "await-to-js";
import { t } from "i18next";
import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "../../../components/Button/Button";
import { ModalsContext } from "../../../context/modals.context";
import { ExciseStampsContext } from "../../../modules/obligee/exciseStamps/exciseStamps.context";
import { exciseStampsService } from "../../../modules/obligee/exciseStamps/exciseStamps.service";
import { downloadFile } from "../../../utils/fileDownload";
import { toastService } from "../../../utils/toast.service";
import style from "./RequestSuccessfullySent.module.scss";

interface IRequestSuccessfullySentProps {
  type: string;
}

export const RequestSuccessfullySent: React.FC<
  IRequestSuccessfullySentProps
> = ({ type }) => {
  const { exciseStamps } = useContext(ExciseStampsContext);
  const { setError } = useContext(ModalsContext);

  const navigate = useNavigate();
  const location = useLocation();

  const handleText = () => {
    if (type === "markice")
      return location?.state?.isEdit
        ? t("AKCIZNE_MARKICE.ZAHTEV_ZA_AKCIZNU_MARKICU_JE_USPESNO_DOPUNJEN")
        : t("AKCIZNE_MARKICE.ZAHTEV_ZA_AKCIZNU_MARKICU_JE_USPESNO_PODNET");
    if (type === "dozvole")
      return t("AKCIZNE_MARKICE.ZAHTEV_ZA_AKCIZNU_DOZVOLU_JE_USPESNO_PODNET");
    return t(
      "AKCIZNE_MARKICE.ZAHTEV_ZA_IZMENU_AKCIZNE_DOZVOLE_JE_USPESNO_PODNET"
    );
  };

  const handlePrintPDF = async () => {
    const [err, res] = await to(
      exciseStampsService.postGenerisiZahtevZaMarkicuPdf({
        zahtevMarkicaId:
          exciseStamps.zahtevMarkicaId || exciseStamps.selectedMarkicaId,
      })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.DOWNLOAD_SUCCESS");

    downloadFile(
      res.data.content,
      type === "markice" && exciseStamps?.evidencioniBroj
        ? `AM-${exciseStamps?.evidencioniBroj}`
        : `izvestaj`,
      "pdf"
    );
  };

  const handleButtonContainer = () => {
    if (type === "markice") {
      return (
        <>
          <Button type="primary" className="mr-10" onClick={handlePrintPDF}>
            {t("AKCIZNE_MARKICE.PREUZMI_ZAHTEV")}
          </Button>
          <Button
            onClick={() => navigate("/obveznik/akcizneMarkice/noviZahtev")}
            type="primary"
          >
            {t("AKCIZNE_MARKICE.KREIRAJ_NOVI_ZAHTEV")}
          </Button>
        </>
      );
    }
    if (type === "dozvole") {
      return (
        <>
          <Button
            onClick={() => navigate("/obveznik/akcizneDozvole/noviZahtev")}
            type="primary"
          >
            {t("AKCIZNE_MARKICE.KREIRAJ_NOVI_ZAHTEV")}
          </Button>
        </>
      );
    }
  };

  return (
    <main className={style.main}>
      <div className={style.mainContainer}>
        <div className={style.subContainer}>
          <span className={style.iconContainer}>
            <CheckCircleFilled />
          </span>
          <div className={style.title}>{handleText()}</div>
          <div className={style.subtitle}>
            {t(
              "AKCIZNE_MARKICE.HVALA_VAM_STO_KORISTITE_USLUGE_PORTALA_EAKCIZE"
            )}
          </div>
          <div className={style.buttonContainer}>{handleButtonContainer()}</div>
        </div>
      </div>
    </main>
  );
};
